/// <amd-module name="Wit/LinkedWorkItemsDropdown/Components/LinkedWorkItemsCheckinChanges" />
import * as React from "react";
import { Components } from "VSS/Platform/Layout";
import { IArtifactLink } from "../LinkedWorkItemsService";
import { ArtifactCompleteListener, getChangesetArtifactLink } from "../Util/Artifact";
import { ILinkedWorkItemsDropdownProps, LinkedWorkItemsDropdown } from "./LinkedWorkItemsDropdown";

export interface ICheckinChangesContext {
    addCheckinCompleteListener: (listener: CheckinCompleteListener) => void;
}

export declare type CheckinCompleteListener = (changesetRef: TfvcChangesetRef) => void | Promise<void>;

export interface TfvcChangesetRef {
    changesetId: number;
}

export interface ILinkedWorkItemsCheckinChangesProps {
    checkinChangesContext: ICheckinChangesContext;
}

export class LinkedWorkItemsCheckinChanges extends React.Component<ILinkedWorkItemsCheckinChangesProps> {
    private artifactListener: ArtifactCompleteListener | undefined;

    public render(): JSX.Element {
        const linkedWorkItemsProps: ILinkedWorkItemsDropdownProps = {
            artifactChangesContext: {
                addArtifactCompleteListener: (listener: (artifactLinks: IArtifactLink[]) => Promise<void> | void): void => {
                    this.artifactListener = listener;
                    this.props.checkinChangesContext.addCheckinCompleteListener(this.linkWorkItems);
                }
            }
        };

        return <LinkedWorkItemsDropdown {...linkedWorkItemsProps} />;
    }

    private linkWorkItems = (changesetRef: TfvcChangesetRef): Promise<void> | void => {
        if (this.artifactListener) {
            const artifactLinks: IArtifactLink[] = [];

            // Add checkin artifact link first
            artifactLinks.push(getChangesetArtifactLink(changesetRef.changesetId));

            return this.artifactListener(artifactLinks);
        }
    };
}

Components.add("WIT.LinkedWorkItemsCheckinChanges", LinkedWorkItemsCheckinChanges);
